
const Api = window.location.origin;

// const Api = "http://api-iraqsoft.com:10321";
// const Api = "http://localhost:3091";
export default Api;